export default {
  en: {
    analyzeAuth: 'Authentication',
    analyzeHistory: 'History',
    analyzeOverview: 'Overview',
    analyzeProcess: 'Analyze process',
    configReg: 'Config Register',
    day: 'day',
    days: 'days',
    device: 'device',
    devices: 'devices',
    deviceStability: 'Device stability',
    discoveryAuth: 'Authentication',
    discoveryOverview: 'Overview',
    discoveryProcess: 'Discovery process',
    discoverySeedIpList: 'Seed - ipList',
    documentation: 'Documentation',
    eula: 'EULA',
    graph: 'Graph',
    home: 'Home',
    hsrp: 'HSRP',
    hsrpDevice: 'HSRP Device Active/Standby Ratio',
    hsrpStatus: 'HSRP Status',
    hsrpVip: 'HSRP/VRRP Group members',
    interfaces: 'Interfaces',
    interfacesDrops: 'Drops per Interface',
    interfacesDropsTotal: 'Drops per Device',
    interfacesDuplicitIp: 'Duplicit IP',
    interfacesErrors: 'Errors per Interface',
    interfacesInfo: 'Info',
    interfacesManagedIp: 'Managed IP',
    interfacesTotal: 'Errors per Device',
    inventory: 'Inventory',
    licenseBoxExpired: 'License Expired',
    licenseBoxExpiredShort: 'Expired',
    licenseBoxExpiredTooltip: 'License expired',
    licenseBoxExpiresIn: 'License expires in {remainsDays} {days}',
    licenseBoxExpiresInShort: '{remainsDays} {days}',
    licenseBoxMissing: 'Missing License',
    licenseBoxMissingShort: 'Missing',
    licenseBoxError: 'License Error',
    licenseBoxErrorShort: 'Error',
    licenseDeviceLimit: 'Limited',
    licenseDeviceLimitTooltip: 'License limit reached',
    licenseExpired: 'License is expired!',
    licenseExpiredShort: 'Expired',
    licenseLimit: 'Licensed devices',
    licenseValidTo: 'Valid until {date}',
    nimpeeVersion: 'Software version:',
    newUpdate: 'New update available!',
    login: 'Login',
    logout: 'Log out',
    me: 'Me (protected)',
    profileSettings: 'Profile Settings',
    reload: 'Reload',
    spanningTree: 'Spanning Tree',
    spanningTreeHsrp: 'STP root and HSRP active mismatch',
    spanningTreeRootDistance: 'STP root distance',
    spanningTreeTopology: 'STP topology changes',
    startAnalyze: 'Start Analyze process',
    statusMessage: 'Status',
    support: 'Support',
    supportDiagnostics: 'Send Diagnostics',
    supportPortal: 'Support Portal',
    supportTechsupport: 'Generate Techsupport',
    supportVpn: 'Remote support VPN',
    toggleNavigation: 'Toggle navigation',
    uploadLicense: 'Upload License',
    userProfile: 'Profile',
    userSettings: 'Settings',
    attributeFilters: {
      addFilter: 'Add attribute',
      filterActive: 'Attribute',
      attributeFilters: 'Attribute filter',
      cancel: 'Cancel',
      apply: 'Apply',
    },
  },
};
